import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// ---------- Sentry (graceful no-op when REACT_APP_SENTRY_DSN is unset) ----------
const sentryDsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^\//, /r2\.cloudflarestorage\.com/],
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const Fallback = () => (
  <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "#888" }}>
    Something went wrong. Please refresh the page.
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<Fallback />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
